import TeamsDetails from './TeamsDetails';

export default TeamsDetails;
